/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneRichtextbox from 'base/components/standalone/Richtextbox';

export const DynamicStandaloneRichtextbox = StandaloneRichtextbox;
export type DynamicStandaloneRichtextboxProps = PropsFromComponent<typeof StandaloneRichtextbox>;

export const DynamicStandaloneRichtextboxWith = (extras: DynamicStandaloneExtras): typeof StandaloneRichtextbox => {
    return function DynamicStandaloneRichtextbox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Richtextbox');
        return <StandaloneRichtextbox {...mergeProps({ options: { theme } }, props)} />;
    }
}